export default __webpack_public_path__ + "static/media/file-05.d12eba9c.svg";